export const VERSION = '2.48.1';
